<template>
  <v-layout wrap :class="justify">
    <v-flex md6 xs12 mt-2 class="pl-md-3 px-0">
      <p class="text-right display-22 mb-1">
        <strong>{{ text }}</strong>
      </p>
      <ComboBox
        :selected="selected"
        :items="items"
        :disabled="disabled"
        @categorySelected="displayCorrespondingSubCats"
        @unselect="handleUnselect"
        :category-num="categoryNum"
        :category-type="'category'"
      />
    </v-flex>
    <v-flex md6 xs12 mt-2 class="pr-md-3 px-0">
      <p class="text-right display-22 nowrap mb-1">
        <strong>בחירת תחומים</strong>
      </p>
      {{ usersSelectedCategory }}
      <ComboBox
        :selected="usersSelectedCategory"
        :items="subCategories"
        :multiple="true"
        :counter="6"
        :label="delimiterMsg"
        :category-num="categoryNum"
        :category-type="'subcategory'"
        @addSubCat="handleAddSubCat"
        @unselect="handleUnselect"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import { isEqual, isNil } from 'lodash';
import { map } from 'lodash';
import { mapGetters } from 'vuex';
import ComboBox from '@/components/Wrappers/ComboBox/ComboBox';
import { comboRules } from '@/lib/rules.js';

export default {
  components: {
    ComboBox,
  },

  props: {
    justify: {
      type: String,
      default: 'justify-space-around',
      required: false,
    },
    items: {
      type: Array,
    },

    disabled: {
      type: Boolean,
    },

    selected: {
      type: [Number, Object],
    },

    categoryNum: {
      type: Number,
    },
    text: {
      type: String,
    },
    cols: {
      type: Number,
    },
  },

  data() {
    return {
      subCategories: undefined,
      delimiterMsg: 'בחר עד 6 תחומים',
      selectedCategory: undefined,
      selectedSubCategories: undefined,
      comboRules,
    };
  },

  computed: {
    ...mapGetters({
      getCategoryByCode: 'getCategoryByCode',
    }),

    usersSelectedCategory() {
      return this.selected ? this.getCategoryByCode(this.selected) : '';
    },
  },

  methods: {
    displayCorrespondingSubCats(selectedCategory) {
      if (this.selectedCategory) {
        const packageEvent = {
          cat: selectedCategory,
          catNum: this.categoryNum,
        };
        this.$bus.$emit('annulateSelectedChips', packageEvent);
      }
      this.selectedCategory = selectedCategory;

      if (!isNil(this.selectedCategory)) {
        this.subCategories = selectedCategory.Areas;
      } else {
        this.subCategories = undefined;
      }

      this.displayCategory();
    },

    handleUnselect(event) {
      if (
        isEqual(this.categoryNum, event.categoryNum) &&
        event.categoryType === 'category'
      ) {
        this.displayCorrespondingSubCats(event.item);
      }
    },

    unselectCat(categoryNum) {
      this.selectedCategory = undefined;
      this.$emit('unselectCat', categoryNum);
    },

    displayCategory() {
      this.$emit('displaySelectedCategory', this.selectedCategory);
    },

    handleAddSubCat(subCategoriesArr) {
      this.selectedSubCategories = [];
      this.selectedSubCategories = map(subCategoriesArr, 'Code');
      this.$emit('selectSubCategories', this.selectedSubCategories);
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-right: 10px;
}

@media only screen and (min-width: 600px) {
}
</style>
